import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '@Services/apiAxios';

/* ================= TYPES ================= */

interface CreditTransactionReportResponse {
  msg: string;
  data: {
    url: string;
  };
}

interface ReportState {
  loading: boolean;
  url: string | null;
  error: string | null;
}

interface Params {
  currentPage: number;
  perPage: number;
  fromDate: string;
  toDate: string;
  carrierId: string;
}

/* ================= THUNK ================= */

export const downloadCreditTransactionReport = createAsyncThunk<
  CreditTransactionReportResponse,
  Params,
  { rejectValue: string }
>('report/downloadCreditTransactionReport', async (params, { rejectWithValue }) => {
  try {
    const res = await API.get('/invoice/purchase-invoice/downloadCreditTransactionReport', {
      params,
    });

    return res.data;
  } catch (err: any) {
    return rejectWithValue(err?.response?.data?.msg || 'Failed to download report');
  }
});

/* ================= SLICE ================= */

const initialState: ReportState = {
  loading: false,
  url: null,
  error: null,
};

const reportSlice = createSlice({
  name: 'downloadCreditTransactionPurchaseInvoiceReport',
  initialState,
  reducers: {
    resetCreditTransactionPurchaseInvoiceReport: state => {
      state.url = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(downloadCreditTransactionReport.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadCreditTransactionReport.fulfilled, (state, action) => {
        state.loading = false;
        state.url = action.payload.data.url;
      })
      .addCase(downloadCreditTransactionReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

/* ================= EXPORTS ================= */

export const { resetCreditTransactionPurchaseInvoiceReport } = reportSlice.actions;
export default reportSlice.reducer;
